import { useEffect, useState } from "react";
import { DateTime } from "luxon";

const useCountdownV2 = (targetDate: any, timeOffset: any) => {
  const countDownDate = new Date(targetDate).getTime();
  const [countDown, setCountDown] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      const currentTime = DateTime.now()
        .plus({ milliseconds: timeOffset })
        .setZone("Asia/Kolkata")
        .toMillis();
      const difference = countDownDate - currentTime;
      setCountDown(difference > 0 ? difference : 0);
    }, 1000);

    return () => clearInterval(interval);
  }, [countDownDate, timeOffset]);
  return getReturnValues(countDown);
};

const getReturnValues = (countDown: any) => {
  // calculate time left
  const hours = Math.floor(
    (countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((countDown % (1000 * 60)) / 1000);
  let isTimeEnded = 0;
  if (hours === 0 && minutes === 0 && seconds === 0) {
    isTimeEnded = 1;
  }
  return [hours, minutes, seconds, isTimeEnded];
};

export { useCountdownV2 };
